import type { BranchDeliverySystemType } from '../enums/BranchDeliverySystemType'
import type { DeliverySystemType } from '../enums/DeliverySystemType'

export class BranchDeliverySettingFilterEntity {
  name?: string
  type?: DeliverySystemType
  valueType?: BranchDeliverySystemType
  page?: number
  limit?: number
}
